/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOutfitsBySkuQueryVariables = Types.Exact<{
  skuId: Types.Scalars["ID"]["input"];
}>;
export type GetOutfitsBySkuQuery = {
  __typename?: "Query";
  shopProductVariantBySkuId: {
    __typename?: "ShopProductVariant";
    outfitsCollection: {
      __typename?: "WaysToWearItCollection";
      id: string;
      items: {
        __typename?: "CollectionItemsConnection";
        nodes: Array<{
          __typename: "Outfit";
          id: string;
          items: Array<{
            __typename?: "OutfitItem";
            sticker?: {
              __typename?: "ModeStickerLabel";
              label: string;
              theme: Types.ModeStickerLabelTheme;
            } | null;
            laydown: {
              __typename?: "OutfitItemLaydown";
              maxHeight: number;
              maxWidth: number;
              x: number;
              y: number;
              xAnchor: string;
              yAnchor: string;
            };
            shopProductVariant?: {
              __typename?: "ShopProductVariant";
              sku: string;
              url: string;
              image?: {
                __typename?: "ShopMedia";
                id: string;
                altText: string;
                imageUrl: string;
              } | null;
            } | null;
          }>;
        } | {
          __typename: "Product";
        }>;
      };
    };
  };
};
export type ShopProductOutfitsCollectionFragment = {
  __typename?: "ShopProductVariant";
  outfitsCollection: {
    __typename?: "WaysToWearItCollection";
    id: string;
    items: {
      __typename?: "CollectionItemsConnection";
      nodes: Array<{
        __typename: "Outfit";
        id: string;
        items: Array<{
          __typename?: "OutfitItem";
          sticker?: {
            __typename?: "ModeStickerLabel";
            label: string;
            theme: Types.ModeStickerLabelTheme;
          } | null;
          laydown: {
            __typename?: "OutfitItemLaydown";
            maxHeight: number;
            maxWidth: number;
            x: number;
            y: number;
            xAnchor: string;
            yAnchor: string;
          };
          shopProductVariant?: {
            __typename?: "ShopProductVariant";
            sku: string;
            url: string;
            image?: {
              __typename?: "ShopMedia";
              id: string;
              altText: string;
              imageUrl: string;
            } | null;
          } | null;
        }>;
      } | {
        __typename: "Product";
      }>;
    };
  };
};
export type OutfitFragment = {
  __typename?: "Outfit";
  id: string;
  items: Array<{
    __typename?: "OutfitItem";
    sticker?: {
      __typename?: "ModeStickerLabel";
      label: string;
      theme: Types.ModeStickerLabelTheme;
    } | null;
    laydown: {
      __typename?: "OutfitItemLaydown";
      maxHeight: number;
      maxWidth: number;
      x: number;
      y: number;
      xAnchor: string;
      yAnchor: string;
    };
    shopProductVariant?: {
      __typename?: "ShopProductVariant";
      sku: string;
      url: string;
      image?: {
        __typename?: "ShopMedia";
        id: string;
        altText: string;
        imageUrl: string;
      } | null;
    } | null;
  }>;
};
export type OutfitItemFragment = {
  __typename?: "OutfitItem";
  sticker?: {
    __typename?: "ModeStickerLabel";
    label: string;
    theme: Types.ModeStickerLabelTheme;
  } | null;
  laydown: {
    __typename?: "OutfitItemLaydown";
    maxHeight: number;
    maxWidth: number;
    x: number;
    y: number;
    xAnchor: string;
    yAnchor: string;
  };
  shopProductVariant?: {
    __typename?: "ShopProductVariant";
    sku: string;
    url: string;
    image?: {
      __typename?: "ShopMedia";
      id: string;
      altText: string;
      imageUrl: string;
    } | null;
  } | null;
};
export const OutfitItemFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "OutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const OutfitFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Outfit"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Outfit"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "items"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OutfitItem"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "OutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const ShopProductOutfitsCollectionFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ShopProductOutfitsCollection"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "outfitsCollection"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "items"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "nodes"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "__typename"
                    }
                  }, {
                    kind: "InlineFragment",
                    typeCondition: {
                      kind: "NamedType",
                      name: {
                        kind: "Name",
                        value: "Outfit"
                      }
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "Outfit"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "OutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Outfit"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Outfit"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "items"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OutfitItem"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetOutfitsBySkuDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getOutfitsBySku"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "skuId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariantBySkuId"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "skuId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "skuId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ShopProductOutfitsCollection"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "OutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Outfit"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Outfit"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "items"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OutfitItem"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ShopProductOutfitsCollection"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "outfitsCollection"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "items"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "nodes"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "__typename"
                    }
                  }, {
                    kind: "InlineFragment",
                    typeCondition: {
                      kind: "NamedType",
                      name: {
                        kind: "Name",
                        value: "Outfit"
                      }
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "Outfit"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetOutfitsBySkuQuery__
 *
 * To run a query within a React component, call `useGetOutfitsBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutfitsBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutfitsBySkuQuery({
 *   variables: {
 *      skuId: // value for 'skuId'
 *   },
 * });
 */
export function useGetOutfitsBySkuQuery(baseOptions: Apollo.QueryHookOptions<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables> & ({
  variables: GetOutfitsBySkuQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>(GetOutfitsBySkuDocument, options);
}
export function useGetOutfitsBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>(GetOutfitsBySkuDocument, options);
}
// @ts-ignore
export function useGetOutfitsBySkuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>;
export function useGetOutfitsBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutfitsBySkuQuery | undefined, GetOutfitsBySkuQueryVariables>;
export function useGetOutfitsBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>(GetOutfitsBySkuDocument, options);
}
export type GetOutfitsBySkuQueryHookResult = ReturnType<typeof useGetOutfitsBySkuQuery>;
export type GetOutfitsBySkuLazyQueryHookResult = ReturnType<typeof useGetOutfitsBySkuLazyQuery>;
export type GetOutfitsBySkuSuspenseQueryHookResult = ReturnType<typeof useGetOutfitsBySkuSuspenseQuery>;
export type GetOutfitsBySkuQueryResult = Apollo.QueryResult<GetOutfitsBySkuQuery, GetOutfitsBySkuQueryVariables>;